import { Intercom } from "@bloomberg/intercom";

import { mediaGatewayClient } from "~config/mediaGatewayClient";
import { personalizationClient } from "~config/personalizationClient";
import { userApiClient } from "~config/userApiClient";

const intercom = Intercom.init({
    apiEndpoints: {
        getStories: "/article/api/daper/stories",
    },
});

intercom.mediaGatewayClient = mediaGatewayClient;
intercom.personalizationClient = personalizationClient;
intercom.userApiClient = userApiClient;

export default intercom;
